$(document).ready(function(){
  $('.shop-by-category-wrappera').slick({
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 2
      }
    }
  ]
});
})